export const Theme = {
  primary: "#3A6FF8",
  primaryLight: "#EBF0FF",
  secondary: "#111827",
  tertiary: "#495469",
  white: "#FFFFFF",
  grey: "#8C8C8C",
  secondaryGrey: "#D6D6D6",
  tertiaryGrey: "#62708D",
};
